import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const textVariants = cva("", {
  variants: {
    variant: {
      "display-xl": "font-display font-bold text-[64px] leading-[1.0625] tracking-[-0.025em]",
      "display-l": "font-display font-bold text-[48px] leading-[1.1666] tracking-[-0.02em]",
      h1: "font-display font-semibold text-[36px] leading-[1.222] tracking-[-0.018em]",
      h2: "font-display font-semibold text-[28px] leading-[1.285] tracking-[-0.015em]",
      h3: "font-display font-semibold text-[22px] leading-[1.363] tracking-[-0.01em]",
      h4: "font-display font-semibold text-[18px] leading-[1.444] tracking-[-0.005em]",
      "body-l": "text-[17px] leading-[1.529]",
      body: "text-[15px] leading-[1.466]",
      small: "text-[13px] leading-[1.384] text-slate",
      cap: "text-[12px] leading-[1.333] font-medium tracking-[0.04em] uppercase text-slate",
      mono: "font-mono",
    },
  },
  defaultVariants: { variant: "body" },
});

type TextElement = "p" | "span" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "div" | "label";

interface TextProps extends VariantProps<typeof textVariants> {
  as?: TextElement;
  className?: string;
  children: React.ReactNode;
}

function Text({ as: Tag = "p", variant, className, children }: TextProps) {
  return <Tag className={cn(textVariants({ variant }), className)}>{children}</Tag>;
}

export { Text, type TextProps };
